import { DOCUMENT } from '@angular/common';
import { Component, ContentChild, ContentChildren, ElementRef, Inject, Input, PLATFORM_ID, QueryList, Renderer2 } from '@angular/core';

@Component({
  selector: 'brt-renderer',
  templateUrl: './renderer.component.html',
  styleUrl: './renderer.component.scss'
})
export class RendererComponent {
  @Input({ required: true }) elementId!: string;
  @Input({ required: true }) content!: string;
  @Input() tag = 'div';
  @Input() type?: string;

  constructor(
    private renderer: Renderer2, private el: ElementRef,
    @Inject(DOCUMENT) private _document: Document) { }



  ngAfterViewInit(): void {
    //prevent double rendering (SSR & browser)
    if (this._document.getElementById(this.elementId)) return;

    const parent = this.renderer.createElement(this.tag);
    parent.id = this.elementId;
    switch (this.tag) {
      case 'script':
        if (this.type)
          parent.type = this.type;
        parent.innerText = this.content;
        break;
      default:
        parent.innerHTML = this.content;
        break;
    }

    this.renderer.appendChild(this.el.nativeElement, parent);
  }

}
